import CardPreview from 'components/messagePreview/components/CardPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { RcsMessage, RcsMessageCard } from 'types/rcs';

interface RcsCardPreviewProps {
  card: RcsMessageCard;
  isLoading: boolean;
  message: RcsMessage;
  /** If true, the preview will not be interactive */
  inert?: boolean;
}

const RcsCardPreview = ({
  card,
  isLoading,
  message,
  inert,
}: RcsCardPreviewProps) => {
  return (
    <>
      <CardPreview
        card={isLoading ? { ...card, text: 'Loading...', title: '' } : card}
      />
      <SuggestedActionsPreview
        suggestedActions={message.suggestedActions}
        inert={inert}
      />
    </>
  );
};

export default RcsCardPreview;
